import * as Actions from '../actions/loadStatePhysical.actions'

const initialState = {
  statePhysicalList: [],
}

export default function (state = initialState, action) {
  const newState = { ...state }
  switch (action.type) {
    case Actions.GET_STATE_PHYSICAL_SUCCESS: {
      return {
        ...newState,
        statePhysicalList: [...action.data],
      }
    }
    default: {
      return newState
    }
  }
}
